module.exports = __webpack_public_path__ + "img/grand-vitra-namebanner.1f111b35.svg";